$shm_hitalama_map_widget_float $shm_hitalama_map_float
	widget $shm_hitalama_map_widget
		link_str => link_str
	map $shm_hitalama_map
	title? \
	-
	scrollable true
	plugins /
		^
		<= Hovered $shm_hitalama_hovered
			hovered? <=> hovered? false
	Open_in_new $mol_link_iconed 
		sub /
			<= Open_in_new_icon $mol_icon_open_in_new
		uri <= open_in_new_uri \
		external true
	head_showed? false
	Fullsize_wrapper $mol_view
		style *
			minHeight <= fullsize_min_height \100%
			minWidth \100%
			color <= color
			fontSize <= font_size_px
			fontFamily <= font_family
		sub <= content /
			^ controls /
	head_view /
		<= Widget_head $mol_view
			sub <= head /
				<= Widget_title $mol_text
					text <= title \
			event *
				pointerdown? <=> content_pointerdown? null
	sub_common /
		^ drag_overlap
		^ outline
		^ edges
		^ toolbar
		^ sidebar
		- ^ arrow_settings /
			<= Arrow_settings $mol_view
	sub_scrollable /
		^ head_view
		<= Content_scroll $mol_scroll
			sub <= content_wrapper /
				<= Fullsize_wrapper
			style *
				^
				overflow <= content_scroll_overflow \
				backgroundColor <= background_style \
				borderColor <= border_color_style \
				borderWidth <= border_width_px \0px
				borderStyle <= border_style \solid
			event *
				^
				pointerdown? <=> content_pointerdown? null
		^ sub_common
	sub /
		<= Fullsize_wrapper
		^ sub_common
	-
	auto /
		^
		<= bind_view null
		<= editing false
		<= auto_height_fit null
	Tools $shm_hitalama_map_widget_tools
		widget <= widget
		Map_page <= Map_page
		tools_custom <= tools_custom /
		settings_content <= settings_content /
		settings_tool_visible => settings_tool_visible
		settings_bubble_content => settings_bubble_content
	Contextmenu $shm_hitalama_map_widget_contextmenu
		widget <= widget
		Map_page <= Map_page
		Contextmenu_common => Contextmenu_common
	toolbar /
		<= Toolbar $mol_view
			style *
				transform <= toolbar_transform
				top <= toolbar_style_top \0
			sub /
				<= Toolbar_top $mol_view
					sub /
						- <= Toolbar_widget_title $mol_paragraph
							title <= title
						<= Link_str $mol_paragraph
							title <= link_str
						<= Toolbar_type $mol_paragraph
							title <= toolbar_type \
				<= Tools
	delete_from_map null
	drag_overlap /
		<= Drag_overlap $mol_view
			style *
				pointerEvents <= drag_overlap_pointer_events \none
			event *
				pointerdown? <=> content_pointerdown? null
	opacity? 1
	has_scrollbar_x false
	has_scrollbar_y false
	skip_drag* false
	color \var(--mol_theme_text)
	style *
		^
		opacity <= opacity_str \1
	font_size_px \
	font_family \
	event *
		^
		contextmenu? <=> event_contextmenu? null
		pointerdown? <=> pointerdown? null
	on_contextmenu? null
	locked? false
	z? 0
	Contextmenu_body $mol_list
		sub /
			^ contextmenu_body /
				<= Contextmenu_common
	selected? false
	attr *
		^
		shm_hitalama_map_widget_float_selected <= selected_attr false
		shm_hitalama_map_widget_float_dragged <= dragged_attr false
		shm_hitalama_map_widget_float_locked_selected <= locked_selected false
		shm_hitalama_map_widget_float_locked <= locked?
		shm_hitalama_map_widget_float_hovered <= hover_styled? false
		shm_hitalama_map_widget_float_inner <= is_inner? false
		shm_hitalama_map_widget_float_control <= control_attr? false
